import $ from 'jquery';
import _ from 'underscore';
import Backbone from "backbone";
import RSVP from "rsvp";

const CLASSNAME = "DeletionSource";
const TYPE = Object.freeze({
    "DEFAULT":"default",
    "TEXT_SEARCH":"text_search",
    "AI_EDIT_SUGGESTION_SEARCH":"ai_edit_suggestion_search",
    "DISFLUENCY_SEARCH":"disfluency_search",
    "SILENCE_SEARCH":"silence_search",
    "FILLER_WORD_SEARCH":"filler_word_search",
    "MCP":"mcp",
});
const SOURCE = Object.freeze({
    "MCP_AGENT":"mcp_agent",
});
const DeletionSource =  Backbone.Model.extend({
    idAttribute: "id",

    constructor: function(attributes, options) {
        Backbone.Model.apply(this, [attributes, options]);
    },

    clone: function(){
        return new DeletionSource(this.toJSON());
    },

    getType: function(){
        return this.get("type");
    },
 
    getAppliedInBulk: function(){
        return this.get("appliedInBulk");
    },

    getSource: function(){
        return this.get("source");
    },

    getReason: function(){
        return this.get("reason");
    },

    getCategory: function(){
        return this.get("category");
    },

    getConstructor : function(){
        return DeletionSource;
    },

    afterInstanceCreatedFromConstructorForCloning : function(createdClonedInstance){

    },

    getSerializedData : function(){
        const serializedData = this.toJSON();
        serializedData.classname =  DeletionSource.CLASSNAME;
        return serializedData;
    },

    restoreFromSerializedData: function(serializedData){
        this.set(serializedData);
    },

    cloneJSON: function(){
        const objJson = {};
        objJson.type = this.getType();
        objJson.classname = DeletionSource.CLASSNAME;
        objJson.appliedInBulk = this.getAppliedInBulk();
        return objJson;
    },


});



DeletionSource.CLASSNAME =  CLASSNAME;
DeletionSource.TYPE = TYPE;
DeletionSource.SOURCE = SOURCE;
export default DeletionSource;
